import React from 'react';
import { CoreLink } from 'components/core/library/link';
import { overwriteDisplayName } from '@sparefoot/react-core/tracking-lib';
import { matchPath } from 'react-router-dom';
import { omit } from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import {
	branch,
	compose,
	lifecycle,
	mapProps,
	withPropsOnChange,
	renderComponent,
} from 'recompose';
import { staticRoutes } from 'routes';
import './Link.scss';

export const enhance = compose(
	overwriteDisplayName('Link'),
	withPropsOnChange(
		['className', 'secondary'],
		({ className, secondary, tertiary, quaternary, underline }) => ({
			className: classnames(
				'ss-link',
				{ 'ss-link-secondary': secondary },
				{ 'ss-link-tertiary': tertiary },
				{ 'ss-link-quaternary': quaternary },
				{ 'ss-link-underline': underline },
				className,
			),
		}),
	),
	branch(({ preloadRoute }) => !preloadRoute, renderComponent(Link)),
	lifecycle({
		componentDidMount() {
			const { to } = this.props;
			const matchingRoute = staticRoutes.find((route) =>
				matchPath(to?.split('?')[0], {
					path: route.path || '',
					exact: true,
					strict: true,
				}),
			);
			if (matchingRoute?.component.preload) {
				matchingRoute.component.preload();
			}
		},
	}),
	mapProps((props) => omit(props, ['preloadRoute'])),
);

function Link(props) {
	const {
		href,
		to,
		onClick,
		rel,
		target,
		className,
		children,
		color,
		hideBorder,
		inheritFont,
		productClick,
	} = props;
	return (
		<CoreLink
			href={href}
			to={to}
			onClick={onClick}
			rel={rel}
			target={target}
			className={classnames(className, color, {
				'hide-border': hideBorder,
				inheritFont,
			})}
			productClick={productClick}
		>
			<span className={classnames('link-content', color)}>
				{children}
			</span>
		</CoreLink>
	);
}

Link.propTypes = {
	href: PropTypes.string,
	to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	onClick: PropTypes.func,
	rel: PropTypes.string,
	target: PropTypes.string,
	className: PropTypes.string,
	children: PropTypes.node.isRequired,
	color: PropTypes.string,
	hideBorder: PropTypes.bool,
	inheritFont: PropTypes.bool,
	productClick: PropTypes.func,
};

export default enhance(Link);
